import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listAdmin } from "@/lib/adminApi";
import { FileText, Newspaper, Layers } from "lucide-react";

export default function AdminDashboard() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    Promise.all([
      listAdmin("publications").catch(() => []),
      listAdmin("news").catch(() => []),
      listAdmin("projects").catch(() => []),
    ]).then(([p, n, pr]) => {
      setCounts({
        publications: p.length,
        pubPublished: p.filter((x) => x.status === "published").length,
        news: n.length,
        newsPublished: n.filter((x) => x.status === "published").length,
        projects: pr.length,
        projPublished: pr.filter((x) => x.status === "published").length,
      });
    });
  }, []);

  const cards = [
    { to: "/admin/publications", icon: FileText, label: "الإصدارات المعرفية", total: counts.publications, live: counts.pubPublished },
    { to: "/admin/news", icon: Newspaper, label: "الأخبار", total: counts.news, live: counts.newsPublished },
    { to: "/admin/projects", icon: Layers, label: "المشاريع", total: counts.projects, live: counts.projPublished },
  ];

  return (
    <div>
      <h1 className="font-display text-2xl mb-2">مرحبًا بك في لوحة الإدارة</h1>
      <p className="text-blue/70 mb-8">اختر قسمًا لإدارة محتواه — الإضافة والتعديل تُعرض على الموقع فورًا.</p>
      <div className="grid sm:grid-cols-3 gap-4">
        {cards.map(({ to, icon: Icon, label, total, live }) => (
          <Link
            key={to}
            to={to}
            className="group block bg-white border border-navy/10 p-6 hover:border-coral transition-colors"
            data-testid={`dash-card-${to.split("/").pop()}`}
          >
            <div className="flex items-center gap-3 text-blue mb-4">
              <Icon size={22} />
              <span className="font-display text-lg text-navy">{label}</span>
            </div>
            <div className="flex items-baseline gap-3">
              <span className="text-3xl font-display text-navy">{total ?? "—"}</span>
              <span className="text-xs text-blue/70">إجمالي</span>
            </div>
            {live != null && (
              <div className="mt-1 text-xs text-blue/70">
                {live} منشور
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
